// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8ca10148","455":"a318405e","850":"e4e1e2f3","977":"5b2f9744"}[chunkId] + ".chunk.js";
};